import { render } from "./CarrinhoView.vue?vue&type=template&id=19691648"
import script from "./CarrinhoView.vue?vue&type=script&lang=js"
export * from "./CarrinhoView.vue?vue&type=script&lang=js"

import "./CarrinhoView.vue?vue&type=style&index=0&id=19691648&lang=css"

import exportComponent from "/var/www/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__